export enum PusherEvent {
  VISIT_CREATED = 'visit.created',
  REGISTRATION_CREATED = 'registration.created',
  REGISTRATION_UPDATED = 'registration.updated',
  REGISTRATION_DELETED = 'registration.deleted',
}
